import React, { useRef, useState } from "react";
import { Form, Button, Card, Alert } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";
import { Link, useHistory } from "react-router-dom";
import {useToasts} from "react-toast-notifications";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
// import Link from '@material-ui/core/Link';
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { mainListItems, secondaryListItems } from "./listItems";

export default function Login() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const hospitalCodeRef = useRef();
  const roomNumberRef = useRef();
  const { login, currentUser } = useAuth();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState("");
  const history = useHistory();
  // const {addToast} = useToasts();

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      setError("");
      const user = await login(emailRef.current.value, passwordRef.current.value, hospitalCodeRef.current.value, roomNumberRef.current.value);
      if(user.role==="superadmin") return history.push("/hospitals");
      if(user.role==="admin") return history.push(user.path.toLowerCase());
      if(user.role==="user") {
        console.log(user.path);
        return history.push(user.path.toLowerCase());
      }
    } catch(error) {
      // addToast(error.message, {appearance:"error"});
      setError(error.message);
    }
  }

  return (
    <>
      <Container
        className="d-flex align-center
            justify-content-center"
        style={{ minHeight: "100vh" }}
      >
        <div className="w-100" style={{ maxWidth: "400px" }}>
          <Card className="login-card">
            <Card.Body>
              <h2 className="text-center mb-4">Login</h2>

              {error && <Alert variant="danger">{error}</Alert>}

              <Form onSubmit={handleSubmit}>
                <Form.Group id="email">
                  <Form.Label>Email</Form.Label>
                  <Form.Control type="email" ref={emailRef} required />
                </Form.Group>

                <Form.Group id="password">
                  <Form.Label>Password</Form.Label>
                  <Form.Control type="text" ref={passwordRef} required />
                </Form.Group>

                <Form.Group id="hospitalCode">
                  <Form.Label>HospitalCode</Form.Label>
                  <Form.Control type="text" ref={hospitalCodeRef}/>
                </Form.Group>

                <Form.Group id="roomNumber">
                  <Form.Label>Patient Room Number</Form.Label>
                  <Form.Control type="number" ref={roomNumberRef}/>
                </Form.Group>

                <Button disabled={loading} className="w-100" type="Submit">
                  LOGIN
                </Button>
              </Form>
            </Card.Body>
            {/* <div className="w-100 text-center mt-2 mb-4">
              Don't have an account? <Link to="/signup">Sign Up</Link>
            </div> */}
          </Card>
        </div>
      </Container>
    </>
  );
}
